import { useMemo } from 'react';
import { RefreshCcw, ExternalLink } from 'lucide-react';

export function SiteNotFoundPage() {
  const adminUrl = useMemo(
    () => import.meta.env.VITE_ADMIN_URL || 'https://cultaz.com',
    []
  );

  const currentHost = useMemo(() => window.location.hostname, []);

  return (
    <main className="min-h-screen bg-gradient-to-br from-slate-950 via-indigo-950 to-slate-900 text-white flex items-center justify-center px-4 py-16">
      <div className="relative w-full max-w-4xl overflow-hidden rounded-[2rem] border border-white/10 bg-white/5 p-8 shadow-[0_40px_120px_rgba(15,23,42,0.6)] backdrop-blur-xl">
        <div className="absolute inset-x-0 top-0 h-40 bg-gradient-to-r from-fuchsia-500/20 via-indigo-500/15 to-sky-400/10 blur-3xl" />
        <div className="relative grid gap-10 lg:grid-cols-[1.2fr_0.8fr] lg:items-center">
          <div className="space-y-6">
            <p className="text-sm uppercase tracking-[0.35em] text-sky-300/80">Site not found</p>
            <h1 className="text-5xl font-semibold tracking-tight sm:text-6xl">
              This storefront does not exist yet.
            </h1>
            <p className="max-w-2xl text-base leading-8 text-slate-300">
              We could not resolve <span className="font-semibold text-white">{currentHost}</span> to an active storefront. If you are the store owner, create your store at Cultaz or retry loading the page.
            </p>

            <div className="flex flex-col gap-4 sm:flex-row sm:items-center">
              <a
                href={adminUrl}
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center justify-center gap-2 rounded-full bg-sky-500 px-6 py-3 text-sm font-semibold text-white shadow-lg shadow-sky-500/20 transition hover:bg-sky-400"
              >
                Create your storefront
                <ExternalLink className="h-4 w-4" />
              </a>
              <button
                type="button"
                onClick={() => window.location.reload()}
                className="inline-flex items-center justify-center gap-2 rounded-full border border-white/20 bg-white/10 px-6 py-3 text-sm font-semibold text-white transition hover:bg-white/15"
              >
                Retry
                <RefreshCcw className="h-4 w-4" />
              </button>
            </div>
          </div>

          <div className="rounded-[1.75rem] border border-white/10 bg-slate-950/80 p-8 shadow-2xl shadow-slate-950/30">
            <div className="mb-6 flex items-center justify-between rounded-3xl bg-slate-900/80 p-4 text-slate-300">
              <div>
                <p className="text-xs uppercase tracking-[0.4em] text-slate-500">Environment</p>
                <p className="mt-1 text-sm text-slate-100">Local development</p>
              </div>
              <div className="rounded-full bg-slate-800 px-3 py-1 text-xs uppercase tracking-[0.4em] text-slate-300">No store</div>
            </div>
            <div className="space-y-4 text-slate-300">
              <div className="rounded-3xl bg-slate-900/80 p-4">
                <p className="text-xs uppercase tracking-[0.35em] text-slate-500">Domain</p>
                <p className="mt-2 text-sm font-medium text-white">{currentHost}</p>
              </div>
              <div className="rounded-3xl bg-slate-900/80 p-4">
                <p className="text-xs uppercase tracking-[0.35em] text-slate-500">Next step</p>
                <p className="mt-2 text-sm leading-6 text-slate-300">
                  Make sure your domain is linked in the Cultaz admin. If you already have a storefront, retry after checking the configuration.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}
